
// document.querySelectorAll('.sw_faq_tab_sec .tab-link').forEach(function (tabLink) {
    //     tabLink.addEventListener('click', function () {
    //         var tabID = this.getAttribute('data-tab');

    //         // Remove 'active' from all tab links
    //         document.querySelectorAll('.sw_faq_tab_sec .tab-link').forEach(function (el) {
    //             el.classList.remove('active');
    //         });
    //         // Add 'active' to clicked tab link
    //         this.classList.add('active');

    //         // Remove 'active' from all tab contents
    //         document.querySelectorAll('[id^="tab-"]').forEach(function (content) {
    //             content.classList.remove('active');
    //         });
    //         // Add 'active' to the correct tab content
    //         document.getElementById('tab-' + tabID).classList.add('active');
    //     });
    // });

 document.addEventListener("DOMContentLoaded", function () {
    const tabLinks = document.querySelectorAll(".tab-link");
    const tabContents = document.querySelectorAll(".tab-content");

    tabLinks.forEach(link => {
      link.addEventListener("click", function () {
        const tabID = this.getAttribute("data-tab");

        // Remove active class from all tabs
        tabLinks.forEach(l => l.classList.remove("active"));
        tabContents.forEach(c => c.classList.remove("active"));

        // Add active class to clicked tab and matching content
        this.classList.add("active");
        document.getElementById(tabID).classList.add("active");
      });
    });
  });


// gallery-swiper

// const thumbSlider = new Swiper(".thumb-slider", {
//    loop: true,
//   slidesPerView: 4,
//   spaceBetween: 10,
// //   autoplay: {
// //   delay: 3000,
// //   disableOnInteraction: false,
// // },
//   watchSlidesProgress: true,
//   breakpoints: {
//     0: {
//       slidesPerView: 3, // 👈 For mobile screens (0 - 767px)
//     },
//     768: {
//       slidesPerView: 4, // 👈 For tablets and above
//     }
//   }
// });

// const mainSlider = new Swiper(".main-slider", {
//    loop: true,
// //   autoplay: {
// //   delay: 3000,
// //   disableOnInteraction: false,
// // },
//   spaceBetween: 10,
//   thumbs: {
//     swiper: thumbSlider,
//   },
// });


document.querySelectorAll(".gallery-swiper").forEach(function (container) {
  var blockId = container.dataset.blockId;

  var thumbSlider = new Swiper(`.swiper-thumb-${blockId}`, {
    loop: true,
    slidesPerView: 4,
    spaceBetween: 10,
    watchSlidesProgress: true,
    breakpoints: {
      0: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 4,
      }
    }
  });

  var mainSlider = new Swiper(`.swiper-main-${blockId}`, {
    loop: true,
    spaceBetween: 10,
    thumbs: {
      swiper: thumbSlider,
    },
  });

// Refreshing AOS after Swiper is applied
  AOS.refresh();

  
});

// aaaformbuilder_form start


var checkExist = setInterval(function () {
    var $header = $('.aaaformbuilder_form').find('.section-header');

    if ($header.length > 0) {
        $header.parent().addClass('section-header-wrapper');
        clearInterval(checkExist); // Stop checking once found
    }
}, 100); // Check every 100ms



